import Api from './api.service'

export default {
  create (object) {
    return Api().post('community/channel/create', object)
  },
  delete (id) {
    return Api().delete('community/channel/delete/' + id)
  },
  get (id) {
    return Api().get('community/channel/get/' + id)
  },
  list (filter) {
    return Api().get('community/channel/get', { params: filter })
  },
  RequestList (filter) {
    return Api().get('community/channel/requestList', { params: filter })
  },
  approveOrRejectRequest (object) {
    return Api().post('community/channel/declineApproveJoinRequest', object)
  },
  update (object) {
    return Api().put('community/channel/edit/' + object.id, object.object)
  },
  getPieChart () {
    return Api().get('community/channel/getPiechartInfo')
  },
  getUsers(filter) {
    return Api().get('community/userList', { params: filter });
  },
  createGroup(object) {
    return Api().post('community/createRoom', object);
  },
  editGroup(object) {
    return Api().post(`community/editRoom/${object.id}`, object.object);
  },
  getGroup(id) {
    return Api().get('community/getRoom/' + id);
  },
}